import { Component, Injector, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-user-data-permission',
  templateUrl: './user-data-permission.component.html',
  styleUrls: ['./user-data-permission.component.scss']
})
export class UserDataPermissionComponent extends SessionBaseComponent  implements OnInit {

  readonly helpPermissionCode: PermissionConstants = PermissionConstants.ViewDataPermission;
  currentLang: string = this.laasSetting.language;
  userUuid: string;

  constructor(injector: Injector) {
    super(injector);
    this.userUuid = '';
  }

  async ngOnInit(): Promise<void> {
    try {
      await super.ngOnInit();

      this.userUuid = this.userProfile?.uuid;
    }catch (err) {
      console.log('baseSession Error');
    }
  }

}
